import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const PlusIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-plus-icon ${className}`, height: '13.576', viewBox: '0 0 13.576 13.576', width: '13.576', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsxs("g", Object.assign({ transform: 'translate(-219.486 -258.379) rotate(45)' }, { children: [_jsx("rect", { fill: '#a1a7b2', height: '1.358', rx: '0.679', transform: 'translate(343.182 22.222) rotate(45)', width: '13.576' }), _jsx("rect", { fill: '#a1a7b2', height: '1.358', rx: '0.679', transform: 'translate(352.782 23.182) rotate(135)', width: '13.576' })] })) })));
PlusIcon.propTypes = {
    className: propStr(),
};
PlusIcon.defaultProps = {
    className: '',
};
export default PlusIcon;
